module.exports = __webpack_public_path__ + "static/visual_4-2fe88fd391aad27542f46da7dac97d0a.jpg";